
import { useState, useEffect } from 'react'

export function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getRandomList() {
    const strList = [
        'چار بازار',
        'چهار بازار',
        '4 بازار',
        'چهاربازار',
        '4 bazar',
        '4bazar',
        
        // 'سایت چار بازار',
        // 'سایت چهار بازار',
        // 'سایت چهاربازار',
        // 'سایت 4bazar',
        // 'سایت charbazar',
        // 'سایت chaharbazar',
        // 'سایت chaharbazar.ir',
        // 'سایت charbazar.ir',
        // 'سایت 4 bazar.ir',
        
        // 'چار بازار.ir',
        // 'چهار بازار.ir',
        // 'چهاربازار.ir',
        // 'چاربازار ir',
        // 'چار بازار ir',
        // 'چهار بازار ir',
        // 'چهاربازار ir',
    ]
    const min = 0
    const max = strList.length - 1

    const numSelect = Math.floor(Math.random() * (max - min + 1)) + min;
    return strList[numSelect];
}

export function getRandomFromList(strList) {

    if(strList && strList.length > 0)
    {
        if(strList.length === 1)
        {
            return strList[0]
        }
        const min = 0
        const max = strList.length - 1
    
        const numSelect = Math.floor(Math.random() * (max - min + 1)) + min;
        return strList[numSelect];
    }
    return '';
}

function getWindowDimensions() {
    const hasWindow = typeof window !== 'undefined';
    const width = hasWindow ? window.innerWidth : 0;
    const height = hasWindow ? window.innerHeight : 0;
    return {
        width,
        height,
    };
}

export function useWindowDimensions() {
    const hasWindow = typeof window !== 'undefined';
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        if (hasWindow) {

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    return windowDimensions;
}

export function msToTime(ms) {
    // let seconds = Math.round(ms / 1000);
    let minutes = Math.round(ms / (1000 * 60));
    let hours = Math.round(ms / (1000 * 60 * 60));
    let days = Math.round(ms / (1000 * 60 * 60 * 24));
    if (minutes <= 5 && hours === 0 && days === 0) return 'لحظاتی پیش'//`${seconds} ثانیه`;
    else if (minutes < 15 && hours === 0 && days === 0) return `دقایقی پیش`;
    else if (minutes >= 15 && minutes < 30 && hours === 0 && days === 0) return `یک ربع پیش`;
    else if (minutes >= 30 && minutes < 60 && hours === 0 && days === 0) return `نیم ساعت پیش`;
    // else if (minutes > 60) return `${minutes} دقیقه پیش`;
    else if (hours <= 24 && days === 0) return `${hours} ساعت پیش`;
    else return `${days} روز پیش`;
}

export function convertToEnToAr(tstr) {
    var bstr = '';
    if(tstr)
    {
        for (let i = 0; i < tstr.length; i++) {
            if (tstr.charAt(i) >= '0' && tstr.charAt(i) <= '9') {
                bstr += String.fromCharCode(tstr.charCodeAt(i) + 1728);
            }
            else {
                bstr += tstr.charAt(i);
            }
        }
    }
    return bstr;
}

// export function toEnglishDigits(str:string) {

//     // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
//     var e = '۰'.charCodeAt(0);
//     str = str.replace(/[۰-۹]/g, function(t) {
//         return t.charCodeAt(0) - e;
//     });

//     // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
//     e = '٠'.charCodeAt(0);
//     str = str.replace(/[٠-٩]/g, function(t) {
//         return t.charCodeAt(0) - e;
//     });
//     return str;
// }

export function convertToFaToEn(tstr) {
    var bstr = '';
    for (let i = 0; i < tstr.length; i++) {
        if (tstr.charAt(i) >= '۰' && tstr.charAt(i) <= '۹') {
            bstr += String.fromCharCode(tstr.charCodeAt(i) - 1728);
        }
        else {
            bstr += tstr.charAt(i);
        }
    }
    return bstr;
}

export function formatMoney(resValue, decimalCount = 0, decimal = ".", thousands = ",") {
    try {
        if(resValue)
        {

            let resValue_ = String(resValue).replaceAll(',', '').replaceAll('،', '');
            let amount = Number(resValue_);
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        
            const negativeSign = amount < 0 ? "-" : "";
        
            let i = parseInt(Math.abs(amount || 0).toFixed(decimalCount)).toString();
            // let i:string = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;
        
            return negativeSign +
                (j ? i.substr(0, j) + thousands : '') +
                i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                (decimalCount ? decimal + Math.abs(amount - Number(i)).toFixed(decimalCount).slice(2) : "");
        }
    } catch (e) {
      console.log(e)
    }
    return resValue;
}

export function moneyMil(money){
    if(!money) return "0"
    let ms = Number(money)
    if (ms <= 0) return `توافقی`
    else if (ms < 1000) return `${ms}`
    else{
        var hezar2 = Number((ms / 1000).toFixed(2));
        if (hezar2 < 1000){
            var hezar = Number((ms / 1000).toFixed(0));
            var hezar1 = Number((ms / 1000).toFixed(1));
            if(hezar === hezar2)
                return `${hezar} هزار`
            if(hezar1 === hezar2)
                return `${hezar1} هزار`
            return `${hezar2} هزار`
        } 
        // let hezar:number = Math.round(ms / 1000)
        var milion2 = Number((ms / (1000 * 1000)).toFixed(2));
        if (milion2 < 1000) 
        {
            var milion = Number((ms / (1000 * 1000)).toFixed(0));
            var milion1 = Number((ms / (1000 * 1000)).toFixed(1));
            if(milion === milion2) 
                return `${milion} میلیون`
            if(milion2 === milion1) 
                return `${milion1} میلیون`
            return `${milion2} میلیون`
        }

        var milyard2 = Number((ms / (1000 * 1000 * 1000)).toFixed(2));
        if (milyard2 < 1000) 
        {
            var milyard = Number((ms / (1000 * 1000 * 1000)).toFixed(0));
            var milyard1 = Number((ms / (1000 * 1000 * 1000)).toFixed(1));
            if(milyard === milyard2)
                return `${milyard} میلیارد`
            if(milyard2 === milyard1)
                return `${milyard1} میلیارد`
            return `${milyard2} میلیارد`
        }

        var hemat = Number((ms / (1000 * 1000 * 1000 * 1000)).toFixed(1));
        var hemat1 = Number((ms / (1000 * 1000 * 1000 * 1000)).toFixed(1));
        var hemat2 = Number((ms / (1000 * 1000 * 1000 * 1000)).toFixed(1));
        if(hemat === hemat2)
            return `${hemat} همت`
        if(hemat2 === hemat1)
            return `${hemat1} همت`
        return `${hemat2} همت`
    }
}

export function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? `${h > 9 ? h : `0${h}`}:` : "";
    var mDisplay = m > 0 ? `${m > 9 ? m : `0${m}`}:` : h > 0 ? '00:' : '';
    var sDisplay = s > 0 ? `${s > 9 ? s : `0${s}`}` : m > 0 ? '00' : "";
    return hDisplay + mDisplay + sDisplay; 
}

export function status(res){
    if(res.status >= 200 && res.status < 300)
    {
        return res.json();
    }
    return res.json();
    // throw new Error(res.message);
    // return {
    //     "message": 'خطا در ثبت اطلاعات ...',
    //     'Error' : true
    // }
}